import React, { useEffect, useState } from "react";
import CustomInputField from "../../../../common/CustomInputField";
import { Link, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../../../common/breadcrumb/Breadcrumbs";
import {
  getdmtchargesSettings,
  adddmtcomm,
  getdmtcommagId,
  getdmtcommscheme,
  getDmtCommSchemeID,
  relatedService,
  relatedService2,
  updatedmtcommagId,
} from "../../../../api/login/Login";
import { ToastContainer, toast } from "react-toastify";

function DmtCommisionForm() {
  const [comboData, setcomboData] = useState(null);
  const params = useParams();
  const navigate = useNavigate();
  // const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState([
    {
      sponsor_comm: "",
      sponsor_comm_type: "Flat",
      dmt_comm_id: "",
      start_amt: "0",
      end_amt: "0",
      charge: "0",
      charge_type: "Flat",
      commision :"0",
      commision_type:"Flat",
      distributor_comm: "0",
      distributor_comm_type: "Flat",
      master_distributer_com: "0",
      master_distributer_com_type: "Flat",
      apiProvider: "",
      white_label_comm: "",
      white_label_comm_type: "",
      vendor_commission: [
        {
          vendor_Id: "",
          vendor_com: "",
          vendor_com_type: "",
          vendor_charge: "",
          vendor_charge_type: "",
        },
      ],
    },
  ]);

  const [errors, setErrors] = useState({});

  // const validate = () => {
  //   let validationErrors = {};

  //   formValues.forEach((item, index) => {
  //     if (!item.start_amt) {
  //       validationErrors[`start_amt_${index}`] = "Min Amount is required";
  //     }
  //     if (!item.end_amt) {
  //       validationErrors[`end_amt_${index}`] = "Max Amount is required";
  //     }
  //     if (!item.charge) {
  //       validationErrors[`charge_${index}`] = "Charges are required";
  //     }
  //     if (!item.charge_type) {
  //       validationErrors[`charge_type_${index}`] = "Charge type is required";
  //     }
  //     if (!item.commision) {
  //       validationErrors[`commision_${index}`] = "R Commission is required";
  //     }
  //     if (!item.commision_type) {
  //       validationErrors[`commision_type_${index}`] =
  //         "R Commission type is required";
  //     }
  //     if (!item.distributor_comm) {
  //       validationErrors[`distributor_comm_${index}`] =
  //         "Distributor Commission is required";
  //     }
  //     if (!item.distributor_comm_type) {
  //       validationErrors[`distributor_comm_type_${index}`] =
  //         "Distributor Commission type is required";
  //     }
  //     if (!item.master_distributer_com) {
  //       validationErrors[`master_distributer_com_${index}`] =
  //         "Super Distributor Commission is required";
  //     }
  //     if (!item.master_distributer_com_type) {
  //       validationErrors[`master_distributer_com_type_${index}`] =
  //         "Super Distributor Commission type is required";
  //     }
  //   });

  //   if (!formValues2.name) {
  //     validationErrors.name = "Name is required";
  //   }
  //   if (!formValues2.service_id) {
  //     validationErrors.service_id = "Service is required";
  //   }
  //   if (formValues2.isActive === "") {
  //     validationErrors.isActive = "Status is required";
  //   }

  //   setErrors(validationErrors);
  //   return Object.keys(validationErrors).length === 0;
  // };

  // const isFormValid = () => {
  //   // Check if main form values are present
  //   const isForm2Valid =
  //     formValues2.name &&
  //     formValues2.service_id &&
  //     formValues2.isActive !== "";
  
  //   if (!isForm2Valid) return false;
  
  //   return formValues.every((item) => {
  //     // Always required fields
  //     const baseCheck =
  //       item.commision &&
  //       item.commision_type &&
  //       item.distributor_comm &&
  //       item.distributor_comm_type &&
  //       item.master_distributer_com &&
  //       item.master_distributer_com_type;
  
  //     // Only run vendor commission check if service_id === "188"
  //     const vendorCommissionCheck =
  //       formValues2.service_id === "188"
  //         ? item.vendor_commission?.length > 0 &&
  //           item.vendor_commission.every(
  //             (vc) =>
  //               vc.vendor_Id &&
  //               vc.vendor_com &&
  //               vc.vendor_com_type &&
  //               vc.vendor_charge &&
  //               vc.vendor_charge_type
  //           )
  //         : true;
  
  //     if (formValues2.service_id === "1") {
  //       return (
  //         item.sponsor_comm &&
  //         item.sponsor_comm_type &&
  //         baseCheck &&
  //         vendorCommissionCheck
  //       );
  //     } else {
  //       return (
  //         item.start_amt &&
  //         item.end_amt &&
  //         item.charge &&
  //         item.charge_type &&
  //         baseCheck &&
  //         vendorCommissionCheck
  //       );
  //     }
  //   });
  // };

  const isMissing = (v) => v === "" || v === null || v === undefined;
  

  const validate = () => {
    let validationErrors = {};
  
    // Validate formValues2 fields
    if (!formValues2.name) {
      validationErrors.name = "Name is required";
    }
    if (!formValues2.service_id) {
      validationErrors.service_id = "Service is required";
    }
    if (formValues2.isActive === "") {
      validationErrors.isActive = "Status is required";
    }
  
    // Validate formValues array
    formValues.forEach((item, index) => {
      const addError = (field, message) => {
        validationErrors[`${field}_${index}`] = message;
      };
  
      // Always required fields
      if (isMissing(item.start_amt)) addError("start_amt", "Min Amount is required");
      if (isMissing(item.end_amt)) addError("end_amt", "Max Amount is required");
      if (isMissing(item.charge)) addError("charge", "Charges are required");
      if (isMissing(item.charge_type)) addError("charge_type", "Charge type is required");
      if (isMissing(item.commision)) addError("commision", "R Commission is required");
      if (isMissing(item.commision_type)) addError("commision_type", "R Commission type is required");
      if (isMissing(item.distributor_comm)) addError("distributor_comm", "Distributor Commission is required");
      if (isMissing(item.distributor_comm_type)) addError("distributor_comm_type", "Distributor Commission type is required");
      if (isMissing(item.master_distributer_com)) addError("master_distributer_com", "Super Distributor Commission is required");
      if (isMissing(item.master_distributer_com_type)) addError("master_distributer_com_type", "Super Distributor Commission type is required");
  
      // Conditional: Vendor Commission (service_id === '188')
      if (formValues2.service_id === "188") {
        if (!item.vendor_commission || item.vendor_commission.length === 0) {
          validationErrors[`vendor_commission_${index}`] = "At least one vendor commission is required";
        } else {
          item.vendor_commission.forEach((vc, vcIndex) => {
            const vPrefix = `${index}_${vcIndex}`;
            if (!vc.vendor_Id) validationErrors[`vendor_Id_${vPrefix}`] = "Vendor is required";
            if (isMissing(vc.vendor_com)) validationErrors[`vendor_com_${vPrefix}`] = "Vendor Commission is required";
            if (!vc.vendor_com_type) validationErrors[`vendor_com_type_${vPrefix}`] = "Vendor Commission type is required";
            if (isMissing(vc.vendor_charge)) validationErrors[`vendor_charge_${vPrefix}`] = "Vendor Charge is required";
            if (!vc.vendor_charge_type) validationErrors[`vendor_charge_type_${vPrefix}`] = "Vendor Charge type is required";
          });
        }
      }
  
      // Conditional: Sponsor Commission (service_id === '1')
      if (formValues2.service_id === "1") {
        if (isMissing(item.sponsor_comm)) addError("sponsor_comm", "Sponsor Commission is required");
        if (isMissing(item.sponsor_comm_type)) addError("sponsor_comm_type", "Sponsor Commission type is required");
      }
    });
  
    setErrors(validationErrors);
    
    return Object.keys(validationErrors).length === 0;
  };

  console.log(errors , "Errors")
  

  const isFormValid = () => {
    const isForm2Valid =
      formValues2.name &&
      formValues2.service_id &&
      formValues2.isActive !== "";
  
    if (!isForm2Valid) {
      console.log("formValues2 fields missing:", {
        name: formValues2.name,
        service_id: formValues2.service_id,
        isActive: formValues2.isActive,
      });
      return false;
    }
  
    let allValid = true;
  
    formValues.forEach((item, index) => {
      const missingFields = [];
  
      // Always required
      if (isMissing(item.commision)) missingFields.push("commision");
      if (isMissing(item.commision_type)) missingFields.push("commision_type");
      if (isMissing(item.distributor_comm)) missingFields.push("distributor_comm");
      if (isMissing(item.distributor_comm_type)) missingFields.push("distributor_comm_type");
      if (isMissing(item.master_distributer_com)) missingFields.push("master_distributer_com");
      if (isMissing(item.master_distributer_com_type)) missingFields.push("master_distributer_com_type");
  
      // Conditional vendor check
      if (formValues2.service_id === "188") {
        if (!item.vendor_commission || item.vendor_commission.length === 0) {
         
          allValid = false;
        } else {
          item.vendor_commission.forEach((vc, vcIndex) => {
            const vendorMissing = [];
            if (!vc.vendor_Id) vendorMissing.push("vendor_id");
            if (isMissing(vc.vendor_com)) vendorMissing.push("vendor_com");
            if (!vc.vendor_com_type) vendorMissing.push("vendor_com_type");
            if (isMissing(vc.vendor_charge)) vendorMissing.push("vendor_charge");
            if (!vc.vendor_charge_type) vendorMissing.push("vendor_charge_type");
  
            if (vendorMissing.length > 0) {
              console.log(`Missing vendor fields in form[${index}].vendor_commission[${vcIndex}]:`, vendorMissing);
              allValid = false;
            }
          });
        }
      }
  
      if (formValues2.service_id === "1") {
        if (isMissing(item.sponsor_comm)) missingFields.push("sponsor_comm");
        if (!item.sponsor_comm_type) missingFields.push("sponsor_comm_type");
      } else {
        if (isMissing(item.start_amt)) missingFields.push("start_amt");
        if (isMissing(item.end_amt)) missingFields.push("end_amt");
        if (isMissing(item.charge)) missingFields.push("charge");
        if (isMissing(item.charge_type)) missingFields.push("charge_type");
      }
  
      if (missingFields.length > 0) {
        console.log(`Missing fields in form[${index}]:`, missingFields);
        allValid = false;
      }
    });
  
    return allValid;
  };
  
  
  
  console.log(formValues , "form")
  const toastSuccessMessage = () => {
    toast.success(`${params?.id ? "Update" : "Add"}  Successfully.`, {
      position: "top-center",
    });
  };

  const toastErrorMessage = () => {
    toast.error(`${params?.id ? "Update" : "Add"}  Failed.`, {
      position: "top-center",
    });
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedFormValues = [...formValues];
    updatedFormValues[index][name] = value;
    setFormValues(updatedFormValues);
    const errorKey = `${name}_${index}`;

    // Clear the specific error
    setErrors((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors[errorKey];
      return updatedErrors;
    });
  };
  const [formValues2, setFormValues2] = useState({
    name: "",
    service_id: "",
    isActive: false,
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const cleanFormList = formValues.map((item) => {
        const newItem = { ...item };
        if (formValues2.service_id !== "188") {
          delete newItem.vendor_commission;
        }
        return newItem;
      });
    const clone = {
      name: formValues2.name,
      service_id: formValues2.service_id,
      isActive: formValues2.isActive,
      list: cleanFormList,
    };
    let res;
    if (!params?.id) {
      res = await adddmtcomm(clone);
    } else {
      res = await updatedmtcommagId(params.id, clone);
    }

    if (res.statusCode == 200) {
      toastSuccessMessage();
      setTimeout(() => {
        navigate("/admin/dmt-commision-scheme");
      }, 2000);
    } else {
      toastErrorMessage();
    }
  };

  const addMore = () => {
    setFormValues([
      ...formValues,
      {
        dmt_comm_id: "",
        sponsor_comm: "",
        sponsor_comm_type: "Flat",
        start_amt: "0",
        end_amt: "0",
        charge: "0",
        charge_type: "Flat",
        commision :"0",
        commision_type:"Flat",
        distributor_comm: "0",
        distributor_comm_type: "Flat",
        master_distributer_com: "0",
        master_distributer_com_type: "Flat",
        apiProvider: "",
        white_label_comm: "",
        white_label_comm_type: "",
        vendor_commission: [
            {
              vendor_Id: "",
              vendor_com: "",
              vendor_com_type: "",
              vendor_charge: "",
              vendor_charge_type: "",
            },
          ],
      },
    ]);
  };
  const getSchCombo = async () => {
    try {
      const comboRes = await getdmtcommscheme();
      setcomboData(comboRes?.data);
    } catch (error) {
      alert(error.message);
    }
  };
  const [stateServices, stateSetServices] = useState([]);

  const getDMTid = async () => {
    try {
      const res = await getDmtCommSchemeID();
      stateSetServices(res?.data);
      console.log(res?.data);
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    getSchCombo();
    getDMTid();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (params?.id) {
        const response = await getdmtcommagId(params.id);
        setFormValues(response.data.list);
        setFormValues2({
          name: response.data.name,
          service_id: response.data.service_id,
          isActive: response.data.isActive,
        });
      } else {
        setFormValues([
          {
            dmt_comm_id: "",
            sponsor_comm: "",
            sponsor_comm_type: "Flat",
            start_amt: "0",
            end_amt: "0",
            charge: "0",
            charge_type: "Flat",
            commision :"0",
            commision_type:"Flat",
            distributor_comm: "0",
            distributor_comm_type: "Flat",
            master_distributer_com: "0",
            master_distributer_com_type: "Flat",
            vendor_commission: [
                {
                  vendor_Id: "",
                  vendor_com: "",
                  vendor_com_type: "",
                  vendor_charge: "",
                  vendor_charge_type: "",
                },
              ],
          },
        ]);
      }
    };
    fetchData();
  }, [params?.id]);

  const removeItem = (index) => {
    setFormValues((prevValues) => prevValues.filter((_, i) => i !== index));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues2((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setErrors((pre)=>({...pre , [name]:''}))
  };

  const handleServiceChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues2((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors({})
    setFormValues([
      {
        sponsor_comm: "",
        sponsor_comm_type: "Flat",
        dmt_comm_id: "",
        start_amt: "0",
        end_amt: "0",
        charge: "0",
        charge_type: "Flat",
        commision :"0",
        commision_type:"Flat",
        distributor_comm: "0",
        distributor_comm_type: "Flat",
        master_distributer_com: "0",
        master_distributer_com_type: "Flat",
        apiProvider: "",
        white_label_comm: "",
        white_label_comm_type: "",
        vendor_commission: [
            {
              vendor_Id: "",
              vendor_com: "",
              vendor_com_type: "",
              vendor_charge: "",
              vendor_charge_type: "",
            },
          ],
      },
    ]);
  };
  // const [services, setServices] = useState([]);

  // console.log(formValues2, "formValue2");

  // const fetchSercices = async () => {
  //   try {
  //     const response = await relatedService2();
  //     const userTypeData = response.data;
  //     setServices(userTypeData);
  //   } catch (error) {
  //     console.error("Error fetching User type:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchSercices();
  // }, [params?.id]);

  // add new commission setting for dmt/banktransfer
  const [dmtVendorList, setDmtVendorList] = useState([]);

  useEffect(() => {
    const fetchDMTVendor = async () => {
      try {
        let res = await getdmtchargesSettings();
        if (res?.statusCode == 200) {
          setDmtVendorList(res?.data);
        } else {
          setDmtVendorList([]);
        }
      } catch (error) {}
    };

    fetchDMTVendor();
  }, []);




// ➕ Add new vendor commission at a specific form index
const addVendorCommission = (formIndex) => {
    setFormValues(prev =>
      prev.map((form, i) =>
        i === formIndex
          ? {
              ...form,
              vendor_commission: [
                ...form.vendor_commission,
                {
                  vendor_Id: "",
                  vendor_com: "",
                  vendor_com_type: "",
                  vendor_charge: "",
                  vendor_charge_type: "",
                },
              ],
            }
          : form
      )
    );
  };
  
  // ➖ Remove vendor commission at form[index] and vendor[index]
  const removeVendorCommission = (formIndex, vendorIndex) => {
    setFormValues(prev =>
      prev.map((form, i) =>
        i === formIndex
          ? {
              ...form,
              vendor_commission: form.vendor_commission.filter(
                (_, idx) => idx !== vendorIndex
              ),
            }
          : form
      )
    );
  };
  
  // 📝 Handle vendor commission change
  const handleVendorCommissionChange = (formIndex, vendorIndex, key, value) => {
    setFormValues(prev =>
      prev.map((form, i) =>
        i === formIndex
          ? {
              ...form,
              vendor_commission: form.vendor_commission.map((vendor, j) =>
                j === vendorIndex ? { ...vendor, [key]: value } : vendor
              ),
            }
          : form
      )
    );
    const errorKey = `${key}_${formIndex}_${vendorIndex}`;

    // Clear the specific error
    setErrors((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors[errorKey];
      return updatedErrors;
    });
  };

  return (
    <>
      <Breadcrumbs breadCrumbsTitle={""} />
      <ToastContainer />
      <div className="row m-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-responsive active-projects style-1">
                <div className="tbl-caption tbl-caption-2">
                  <h4 className="heading mb-0">
                    <b>
                      {params?.id ? "UPDATE" : "ADD"} DMT / AEPS Commission
                      Scheme{" "}
                    </b>
                  </h4>
                </div>
                <form
                  className="form-container"
                  style={{ padding: "20px 0", margin: "0 20px" }}
                >
                  <div className="row">
                    <div className="col-xl-4 mb-3">
                      <CustomInputField
                        type="text"
                        value={formValues2.name}
                        errorMsg={errors[`name`]}
                        hasError={errors[`name`]}
                        placeholder="Name"
                        name="name"
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-xl-4 mb-3">
  <select
    className={`form-select ${errors.service_id ? 'is-invalid' : ''}`}
    aria-label="Default select example"
    id="service_id"
    disabled={params?.id}
    name="service_id"
    defaultValue={formValues2?.service_id}
    onChange={handleServiceChange}
    value={formValues2?.service_id}
  >
    <option value="">Select service</option>
    {stateServices &&
      stateServices.map((item) => (
        <option key={item.id} value={item.id}>
          {item.service_name}
        </option>
      ))}
  </select>

  {errors.service_id && (
    <div className="invalid-feedback d-block">{errors.service_id}</div>
  )}
</div>


                    <div className="col-xl-4 mb-3">
                      <select
                        // className="form-select"
                        className={`form-select ${errors.isActive ? 'is-invalid' : ''}`}
                        aria-label="Default select example"
                        name="isActive"
                        value={formValues2.isActive}
                        onChange={handleInputChange}
                      >
                        <option value="">Status</option>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </select>
                      {errors.isActive && (
    <div className="invalid-feedback d-block">{errors.isActive}</div>
  )}
                    </div>
                  </div>
                </form>
                <form className="tbl-captionn" onSubmit={handleSubmit}>
                  {formValues &&
                    formValues?.map((item, index) => (
                      <React.Fragment key={index}>
                             <div
                          className="row"
                          style={{
                            border: "1px solid #ccc",
                            padding: "10px 0",
                            margin: "10px 0",
                          }}
                        >

                     
                        <div
                          className="row"
                          style={{
                            // border: "1px solid #ccc",
                            padding: "10px 0",
                            margin: "10px 0",
                          }}
                        >
                          {formValues2?.service_id === "1" ? (
                            <>
                              <div className="col-xl-4 mb-3">
                                <CustomInputField
                                  type="number"
                                  value={item.sponsor_comm}
                                  hasError={errors[`sponsor_comm_${index}`]}
                                  onChange={(e) => handleChange(e, index)}
                                  errorMsg={errors[`sponsor_comm_${index}`]}
                                  id={`sponsor_comm_${index}`}
                                  placeholder="Sponsor commission"
                                  name="sponsor_comm"
                                />
                              </div>
                              <div className="col-xl-4 mb-3">
                                <select
                                    className={`form-select ${errors[`sponsor_comm_type_${index}`] ? 'is-invalid' : ''}`}
                                  aria-label="Default select example"
                                  id={`sponsor_comm_type_${index}`}
                                  name="sponsor_comm_type"
                                  value={item.sponsor_comm_type}
                                  onChange={(e) => handleChange(e, index)}
                                >
                                  <option value="">
                                    Sponsor Commission type
                                  </option>
                                  <option value="Percent">%</option>
                                  <option value="Flat">RS</option>
                                </select>
                                {errors[`sponsor_comm_type_${index}`] && (
  <div className="invalid-feedback d-block">
    {errors[`sponsor_comm_type_${index}`]}
  </div>
)}
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="col-xl-4 mb-3">
                                <CustomInputField
                                  type="number"
                                  value={item.start_amt}
                                  hasError={errors[`start_amt_${index}`]}
                                  onChange={(e) => handleChange(e, index)}
                                  errorMsg={errors[`start_amt_${index}`]}
                                  id={`start_amt_${index}`}
                                  placeholder="From Amount"
                                  name="start_amt"
                                />
                              </div>
                              <div className="col-xl-4 mb-3">
                                <CustomInputField
                                  type="number"
                                  value={item.end_amt}
                                  hasError={errors[`end_amt_${index}`]}
                                  onChange={(e) => handleChange(e, index)}
                                  errorMsg={errors[`end_amt_${index}`]}
                                  id={`end_amt_${index}`}
                                  placeholder="To Amount"
                                  name="end_amt"
                                />
                              </div>
                              <div className="col-xl-2 mb-3">
                                <CustomInputField
                                  type="number"
                                  value={item.charge}
                                  hasError={errors[`charge_${index}`]}
                                  onChange={(e) => handleChange(e, index)}
                                  errorMsg={errors[`charge_${index}`]}
                                  id={`charge_${index}`}
                                  placeholder="Charges"
                                  name="charge"
                                />
                              </div>
                              <div className="col-xl-2 mb-3">
                                <select
                                  // className="form-select"
                                  className={`form-select ${errors[`charge_type_${index}`] ? 'is-invalid' : ''}`}
                                  aria-label="Default select example"
                                  id={`charge_type_${index}`}
                                  name="charge_type"
                                  value={item.charge_type}
                                  onChange={(e) => handleChange(e, index)}
                                >
                                  <option value="">Charges type</option>
                                  <option value="Percent">%</option>
                                  <option value="Flat">RS</option>
                                </select>
                                {errors[`charge_type_${index}`] && (
  <div className="invalid-feedback d-block">
    {errors[`charge_type_${index}`]}
  </div>
)}
                              </div>
                            </>
                          )}
                      {formValues2?.service_id != "78" && 
                      <>
                    
                          <div className="col-xl-4 mb-3">
                            <CustomInputField
                              type="number"
                              value={item.commision}
                              hasError={errors[`commision_${index}`]}
                              onChange={(e) => handleChange(e, index)}
                              errorMsg={errors[`commision_${index}`]}
                              id={`commision_${index}`}
                              placeholder="R Commission"
                              name="commision"
                            />
                          </div>
                          <div className="col-xl-4 mb-3">
                            <select
                              // className="form-select"
                              className={`form-select ${errors[`commision_type_${index}`] ? 'is-invalid' : ''}`}
                              aria-label="Default select example"
                              id={`commision_type_${index}`}
                              name="commision_type"
                              value={item.commision_type}
                              onChange={(e) => handleChange(e, index)}
                            >
                              <option value="">R commission type</option>
                              <option value="Percent">%</option>
                              <option value="Flat">RS</option>
                            </select>
                            {errors[`commision_type_${index}`] && (
  <div className="invalid-feedback d-block">
    {errors[`commision_type_${index}`]}
  </div>
)}
                          </div>
                          <div className="col-xl-4 mb-3">
                            <CustomInputField
                              type="number"
                              value={item.distributor_comm}
                              hasError={errors[`distributor_comm_${index}`]}
                              onChange={(e) => handleChange(e, index)}
                              errorMsg={errors[`distributor_comm_${index}`]}
                              id={`distributor_comm_${index}`}
                              placeholder="Dist Commission"
                              name="distributor_comm"
                            />
                          </div>
                          <div className="col-xl-4 mb-3">
                            <select
                              // className="form-select"
                              className={`form-select ${errors[`distributor_comm_type_${index}`] ? 'is-invalid' : ''}`}
                              aria-label="Default select example"
                              id={`distributor_comm_type_${index}`}
                              name="distributor_comm_type"
                              value={item.distributor_comm_type}
                              onChange={(e) => handleChange(e, index)}
                            >
                              <option value="">Dist Commission type</option>
                              <option value="Percent">%</option>
                              <option value="Flat">RS</option>
                            </select>
                            {errors[`distributor_comm_type_${index}`] && (
  <div className="invalid-feedback d-block">
    {errors[`distributor_comm_type_${index}`]}
  </div>
)}
                          </div>
                          <div className="col-xl-4 mb-3">
                            <CustomInputField
                              type="number"
                              value={item.master_distributer_com}
                              hasError={
                                errors[`master_distributer_com_${index}`]
                              }
                              onChange={(e) => handleChange(e, index)}
                              errorMsg={
                                errors[`master_distributer_com_${index}`]
                              }
                              id={`master_distributer_com_${index}`}
                              placeholder="S Dist Commission"
                              name="master_distributer_com"
                            />
                          </div>
                          <div className="col-xl-4 mb-3">
                            <select
                              // className="form-select"
                              className={`form-select ${errors[`master_distributer_com_type_${index}`] ? 'is-invalid' : ''}`}
                              aria-label="Default select example"
                              id={`master_distributer_com_type_${index}`}
                              name="master_distributer_com_type"
                              value={item.master_distributer_com_type}
                              onChange={(e) => handleChange(e, index)}
                            >
                              <option value="">S Dist Commission type</option>
                              <option value="Percent">%</option>
                              <option value="Flat">RS</option>
                            </select>
                            {errors[`master_distributer_com_type_${index}`] && (
  <div className="invalid-feedback d-block">
    {errors[`master_distributer_com_type_${index}`]}
  </div>
)}
                          </div>
                          </>}  
                          {/* <div className="col-xl-4 mb-3">
                            <CustomInputField
                              type="number"
                              value={item.white_label_comm}
                              hasError={errors[`white_label_comm${index}`]}
                              onChange={(e) => handleChange(e, index)}
                              errorMsg={errors[`white_label_comm${index}`]}
                              id={`white_label_comm${index}`}
                              placeholder="W label Commission"
                              name="white_label_comm"
                            />
                          </div>
                          <div className="col-xl-4 mb-3">
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              id={`white_label_comm_type_${index}`}
                              name="white_label_comm_type"
                              value={item.white_label_comm_type}
                              onChange={(e) => handleChange(e, index)}
                            >
                              <option value="">W L Commission type</option>
                              <option value="Percent">%</option>
                              <option value="Flat">RS</option>
                            </select>
                          </div>
                          <div className="col-xl-4 mb-3">
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              id={`apiProvider${index}`}
                              name="apiProvider"
                              value={item.apiProvider}
                              onChange={(e) => handleChange(e, index)}
                            >
                              <option value="">API Provider</option>
                              <option value="true">Active</option>
                              <option value="false">Inactive</option>
                            </select>
                          </div> */}
                          {index !== 0 && (
                            <div className="col-xl-4 mb-3">
                              <button
                                className="btn btn-danger"
                                type="button"
                                // onClick={(e) => removeItem(e, index)}
                                onClick={() => removeItem(index)}
                              >
                                Remove
                              </button>
                            </div>
                          )}
                        </div>
                       {formValues2?.service_id === "188" && 
                        <div
                          className="row"
                          style={{
                            // border: "1px solid #ccc",
                            padding: "10px 0",
                            margin: "10px 0",
                          }}
                        >
                          {item?.vendor_commission?.map((value, i) => {
                            return (
                              <>
                                  <div className="col-xl-4 mb-3">

                                 
                                <select
                              // className="form-select"
                              value={value.vendor_Id}
                              className={`form-select ${errors[`vendor_Id_${index}_${i}`] ? 'is-invalid' : ''}`}
                              onChange={(e) =>
                                handleVendorCommissionChange(index, i, "vendor_Id", e.target.value)
                              }
                  
                            >
                              <option value="" disabled>Vendor List</option>
                               {dmtVendorList?.map((vendor)=>
                                <option value={vendor?._id} key={vendor?._id}>{vendor?.slug}</option>
                            )}
                             
                            </select>
                            
                            {errors[`vendor_Id_${index}_${i}`] && (
  <div className="invalid-feedback d-block">
    {errors[`vendor_Id_${index}_${i}`]}
  </div>
)}
                            </div>
                                <div className="col-xl-4 mb-3">
                                  <CustomInputField
                                    value={value.vendor_charge}
                                    hasError={errors[`vendor_charge_${index}_${i}`]}
 errorMsg={errors[`vendor_charge_${index}_${i}`]}
                                    onChange={(e) =>
                                        handleVendorCommissionChange(
                                            index,
                                        i,
                                        "vendor_charge",
                                        e.target.value
                                      )
                                    }
                                    type={'number'}
                                    placeholder="Vendor Charges"
                                  />
                                </div>
                                <div className="col-xl-4 mb-3">
                            <select
                              
                              className={`form-select ${errors[`vendor_charge_type_${index}_${i}`] ? 'is-invalid' : ''}`}
                              value={value.vendor_charge_type}
                              onChange={(e) =>
                                handleVendorCommissionChange(
                                    index,
                                  i,
                                  "vendor_charge_type",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Vendor Charge type</option>
                              <option value="Percent">%</option>
                              <option value="Flat">RS</option>
                            </select>
                            {errors[`vendor_charge_type_${index}_${i}`] && (
  <div className="invalid-feedback d-block">
    {errors[`vendor_charge_type_${index}_${i}`]}
  </div>
)}
                          </div>
                                <div className="col-xl-4 mb-3">
                                  <CustomInputField
                                    value={value.vendor_com}
                                    type={'number'}
                                    hasError={errors[`vendor_com_${index}_${i}`]}
 errorMsg={errors[`vendor_com_${index}_${i}`]}
                                    onChange={(e) =>
                                        handleVendorCommissionChange(
                                            index,
                                        i,
                                        "vendor_com",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Vendor Commission"
                                  />
                                </div>
                                <div className="col-xl-4 mb-3">
                            <select
                              // className="form-select"
                              className={`form-select ${errors[`vendor_com_type_${index}_${i}`] ? 'is-invalid' : ''}`}
                              value={value.vendor_com_type}
                              onChange={(e) =>
                                handleVendorCommissionChange(
                                    index,
                                  i,
                                  "vendor_com_type",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Vendor Commission type</option>
                              <option value="Percent">%</option>
                              <option value="Flat">RS</option>
                            </select>
                            {errors[`vendor_com_type_${index}_${i}`] && (
  <div className="invalid-feedback d-block">
    {errors[`vendor_com_type_${index}_${i}`]}
  </div>
)}
                          </div>
                          <div className="col-4 mb-3">
  <div className="d-flex gap-2 align-items-center">
    <button
      className="btn btn-primary"
      type="button"
      onClick={() => addVendorCommission(index)}
    >
      Add New
    </button>

    {i !== 0 && (
      <button
        className="btn btn-danger"
        type="button"
        onClick={() => removeVendorCommission(index, i)}
      >
        Remove
      </button>
    )}
  </div>
</div>

                              </>
                            );
                          })}
                        </div> }
                        </div>
                      </React.Fragment>
                    ))}
                  <div className="d-flex justify-content-between mt-4 mb-4">
                    <button
                      className="btn btn-secondary"
                      type="button"
                      onClick={addMore}
                    >
                      Add More
                    </button>
                    <div>
                      <Link
                        to="/admin/dmt-commision-scheme"
                        className="btn btn-primary me-2"
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={handleSubmit}
                        // disabled={!params?.id && !isFormValid()}
                      >
                        {params?.id ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </form>
                {/* <div className="d-flex justify-content-center mt-4 mb-4">
                                    
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DmtCommisionForm;
